package com.eladfinish.bible.contest.screens.main.usecases

import com.eladfinish.bible.contest.features.verseWidget.isVerseWidgetPlatform
import com.eladfinish.bible.contest.platform.isWeb
import com.eladfinish.bible.contest.platform.platformSpecific
import com.eladfinish.bible.contest.screens.main.data.ButtonType
import com.eladfinish.bible.contest.screens.main.data.ButtonType.ABOUT
import com.eladfinish.bible.contest.screens.main.data.ButtonType.BROWSE
import com.eladfinish.bible.contest.screens.main.data.ButtonType.COMPLETE_CHAPTER
import com.eladfinish.bible.contest.screens.main.data.ButtonType.COMPLETE_VERSE
import com.eladfinish.bible.contest.screens.main.data.ButtonType.EXIT
import com.eladfinish.bible.contest.screens.main.data.ButtonType.HELP
import com.eladfinish.bible.contest.screens.main.data.ButtonType.LEXICOGRAPHICAL_SORT
import com.eladfinish.bible.contest.screens.main.data.ButtonType.MIKUD
import com.eladfinish.bible.contest.screens.main.data.ButtonType.MISC
import com.eladfinish.bible.contest.screens.main.data.ButtonType.MULTIPLE_CHOICE_QUESTIONS
import com.eladfinish.bible.contest.screens.main.data.ButtonType.NAMES
import com.eladfinish.bible.contest.screens.main.data.ButtonType.OPEN_QUESTIONS
import com.eladfinish.bible.contest.screens.main.data.ButtonType.PAIR_MATCHING
import com.eladfinish.bible.contest.screens.main.data.ButtonType.PAST_QUIZZES
import com.eladfinish.bible.contest.screens.main.data.ButtonType.PYRAMID_CROSSWORD
import com.eladfinish.bible.contest.screens.main.data.ButtonType.RANDOM_VERSE
import com.eladfinish.bible.contest.screens.main.data.ButtonType.RECORDINGS
import com.eladfinish.bible.contest.screens.main.data.ButtonType.REORDER
import com.eladfinish.bible.contest.screens.main.data.ButtonType.SEARCH
import com.eladfinish.bible.contest.screens.main.data.ButtonType.SETTINGS
import com.eladfinish.bible.contest.screens.main.data.ButtonType.TELEGRAM_CHANNEL
import com.eladfinish.bible.contest.screens.main.data.ButtonType.VERSE_WIDGET
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.toImmutableList

class GetMainScreenButtonListUseCase {

    operator fun invoke(isDebugMode: Boolean): ImmutableList<ButtonType> {
        val buttons = platformSpecific(
            forAndroid = { androidButtons },
            forIos = { iosButtons },
            forWeb = { androidButtons },
        )

        return buttons
            .filter {
                @Suppress("SimplifyBooleanWithConstants")
                isDebugMode || FORCE_DEBUG || it.isPublic
            }
            // The web target reuses the Android button list, but there's no way to "exit" a web
            // page from within it the way there is an Android/iOS app.
            .filterNot { it == EXIT && isWeb }
            // Same for the widget: there is no home screen to put it on.
            .filterNot { it == VERSE_WIDGET && !isVerseWidgetPlatform }
            .toImmutableList()
    }

    private val androidButtons = listOf(
        PAST_QUIZZES,
        RANDOM_VERSE,
        VERSE_WIDGET,
        COMPLETE_VERSE,
        SEARCH,
        NAMES,
        COMPLETE_CHAPTER,
        PAIR_MATCHING,
        MULTIPLE_CHOICE_QUESTIONS,
        PYRAMID_CROSSWORD,
        OPEN_QUESTIONS,
        BROWSE,
        MIKUD,
        RECORDINGS,
        TELEGRAM_CHANNEL,
        LEXICOGRAPHICAL_SORT,
        SETTINGS,
        MISC,
        ABOUT,
        HELP,
        REORDER,
        EXIT,
    )

    private val iosButtons = listOf(
        PAST_QUIZZES,
        RANDOM_VERSE,
        VERSE_WIDGET,
        COMPLETE_VERSE,
        SEARCH,
        MIKUD,
        MULTIPLE_CHOICE_QUESTIONS,
        BROWSE,
        NAMES,
        COMPLETE_CHAPTER,
        PAIR_MATCHING,
        PYRAMID_CROSSWORD,
        OPEN_QUESTIONS,
        LEXICOGRAPHICAL_SORT,
        SETTINGS,
        MISC,
        ABOUT,
        HELP, // look for the flag: SHOULD_SHOW_HELP_IN_TOOLBAR
    )

    companion object {
        private const val FORCE_DEBUG = false
    }
}
